const CardCollectionIcon = ({ numberOfCards, numberOfPlayableCards }) => {
  return (
    <svg
      viewBox="0 0 341 145"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <rect
          x={0.43}
          y={21.874}
          width={80}
          height={120}
          rx={10}
          transform="rotate(-9.26 .43 21.874)"
          fill="#D292C0"
        />
        <g clipPath="url(#b)">
          <path
            d="M71.833 31.705 6.09 42.425l10.71 65.682 65.742-10.72-10.71-65.682Z"
            fill="#D292C0"
          />
          <path
            d="M38.591 116.011c-1.463-1.347-12.25-38.737-12.24-40.628.008-1.891 9.792-6.09 19.62-7.692 10.475-1.708 18.933-1.01 19.59 1.087.656 2.097 1.305 41.706.441 43.009-1.26 1.874-7.151 4.166-12.96 5.034-6.257.933-13.077.462-14.452-.815"
            fill="#0093D3"
          />
          <path
            d="M29.02 76.634c.206 1.264 10.752 1.046 18.751-.467 8.71-1.648 16.044-4.577 16.149-5.852.104-1.275-7.752-2.194-17.266-.433-9.515 1.76-17.974 4.603-17.624 6.75"
            fill="#00060C"
          />
          <path
            d="M44.213 73.422c-.258-1.467-.686-5.42-1.326-9.346-.308-1.887-.747-4.987-1.527-5.193-1.274-.321-5.237 2.873-8.883 3.116-3.645.243-9.093-1.562-9.658-2.87-.565-1.31 4.456-4.618 8.731-5.315 4.275-.697 9.123 3.077 9.755 2.638.633-.439-.71-7.6-1.361-9.422-.652-1.823-5.013-5.35-5.303-11.43-.223-4.402 3.291-10.526 4.5-10.723 1.742-.284 6.048 5.794 6.09 11.395.044 5.602-3.417 8.584-3.227 10.834.19 2.25 1.019 8.001 1.643 8.6.624.598 3.801-2.402 9.102-3.266 5.3-.864 10.674 1.328 10.775 2.697.115 1.567-4.138 4.877-8.784 5.46-4.646.583-9.352-2.228-10.22-1.709-.615.365 1.493 12.4 1.743 13.938.251 1.537-1.838 1.817-2.053.599"
            fill="#00923D"
          />
          <path
            d="M39.464 28.789c-1.147.187-2.253 4.512-1.792 7.344.462 2.832 2.135 6.457 2.823 6.345.688-.112 2.107-3.76 1.986-6.963-.087-2.401-1.918-6.9-3.016-6.721"
            fill="#0093D3"
          />
          <path
            d="M39.464 28.789c-1.147.187-2.253 4.512-1.792 7.344.462 2.832 2.135 6.457 2.823 6.345.688-.112 2.107-3.76 1.986-6.963-.087-2.401-1.918-6.9-3.016-6.721v-.005Z"
            stroke="#00060C"
            strokeWidth={0.69}
          />
          <path
            d="M26.654 58.767c.131.804 3.351 1.716 6.32 1.084 2.968-.632 4.938-1.917 4.836-2.562-.103-.644-2.776-1.661-5.478-1.372-2.701.29-5.855 1.764-5.676 2.863"
            fill="#F8C900"
          />
          <path
            d="M26.654 58.767c.131.804 3.351 1.716 6.32 1.084 2.968-.632 4.938-1.917 4.836-2.562-.103-.644-2.776-1.661-5.478-1.372-2.701.29-5.855 1.764-5.676 2.863l-.002-.013Z"
            stroke="#00060C"
            strokeWidth={0.69}
          />
          <path
            d="M48.482 56.823c.055.663 3.988 1.747 6.078 1.488 2.09-.258 5.988-1.84 5.886-2.468-.102-.629-4.086-1.615-6.295-1.29-2.307.34-5.722 1.637-5.669 2.27Z"
            fill="#E73446"
          />
          <path
            d="M48.482 56.823c.055.663 3.988 1.747 6.078 1.488 2.09-.258 5.988-1.84 5.886-2.468-.102-.629-4.086-1.615-6.295-1.29-2.307.34-5.722 1.637-5.669 2.27Z"
            stroke="#00060C"
            strokeWidth={0.69}
          />
        </g>
      </g>
      <rect
        x={2.726}
        y={23.526}
        width={76}
        height={116}
        rx={8}
        transform="rotate(-9.26 2.726 23.526)"
        stroke="#fff"
        strokeWidth={4}
      />
      <g clipPath="url(#c)">
        <rect
          x={36}
          y={11.865}
          width={80}
          height={120}
          rx={10}
          transform="rotate(-3.487 36 11.865)"
          fill="#BCAEAF"
        />
        <path
          d="M121.841 6.635 36 11.865l5.23 85.841 85.841-5.23-5.23-85.84Z"
          fill="#BCAEAF"
        />
        <path
          d="m102.397 7.82-1.381 8.715-9.704-8.04-2.04.125 11.344 10.44-2.615 16.494 11.812 37.92-54.1 5.841-10.14-42.223 9.955-26.062-1.57-.218-9.294 22.489-5.197-21.647-1.044.064-1.036.728 10.778 55.766-8.825-1.52.11 1.807 9.237 2.41 1.735 8.979-10.107 1.09-.08.395.26 4.255 85.778-6.249-.434-7.129-7.487.703-6.03-15.466 11.885-12.018-.178-2.915-13.2 11.104-7.433-19.057 3.72-27.069-4.719.288Z"
          fill="#DAC8CE"
        />
        <path
          d="M57.925 17.935s-4.11 7.336-3.576 21.653c.534 14.316 5.15 40.193 5.15 40.193l1.027-.082v-.883l.336-.04-.018.952.9-.036.013-.995.3-.018.198 1.077.783-.03.073-1.299 17.975-2.013.367 2.337.616.025-.012-2.532.734-.064.193 2.487 1.119-.129-.012-2.532.529-.054.201 2.631.9-.054s5.298-24.386 4.627-41.638c-.671-17.253-3.98-22.158-3.98-22.158l-3.125-.094-2.878 8.584-16.673.826-3.259-6.982-2.508.868Z"
          fill="#E73B28"
        />
        <path
          d="M54.246 35.554c.04 3.002 1.415 8.263 8.357 8.6 6.624.318 9.844-4.15 9.637-8.633-.27-5.888-3.337-8.519-8.595-8.658-6.56-.164-9.452 4.857-9.4 8.681"
          fill="#831F82"
        />
        <path
          d="M72.007 35.168c.04 2.965 1.4 8.163 8.258 8.495 6.542.317 9.724-4.097 9.52-8.527-.265-5.816-3.295-8.417-8.49-8.544-6.48-.159-9.338 4.8-9.292 8.577"
          fill="#831F82"
        />
        <path
          d="M57.188 35.57c.033 2.304 1.086 6.343 6.418 6.6 5.08.245 7.55-3.182 7.395-6.62-.21-4.519-2.561-6.538-6.595-6.637-5.035-.124-7.25 3.725-7.215 6.658"
          fill="#BF318A"
        />
        <path
          d="M64.452 36.983c.013.892.204 2.473 2.48 2.55 2.274.077 2.916-1.229 2.857-2.558-.08-1.746-.99-2.527-2.55-2.565-1.943-.049-2.803 1.438-2.787 2.573"
          fill="#A9924D"
        />
        <path
          d="M67.419 37.715a.87.87 0 0 0 .946.975c.866.03 1.11-.47 1.086-.978-.04-.666-.375-.962-.971-.976a.976.976 0 0 0-1.061.98"
          fill="#1C052E"
        />
        <path
          d="M74.524 35.534c.029 2.25 1.06 6.188 6.259 6.442 4.96.239 7.371-3.106 7.205-6.455-.203-4.42-2.497-6.38-6.435-6.475-4.912-.122-7.08 3.635-7.041 6.498"
          fill="#BF318A"
        />
        <path
          d="M81.006 37.061c.013.95.218 2.65 2.655 2.732 2.436.083 3.127-1.317 3.06-2.741-.086-1.87-1.059-2.706-2.73-2.747-2.083-.05-3.002 1.541-2.998 2.757"
          fill="#A9924D"
        />
        <path
          d="M83.652 37.72a.871.871 0 0 0 .946.975c.866.03 1.11-.47 1.09-.978-.041-.666-.376-.962-.972-.98a.978.978 0 0 0-1.064.983"
          fill="#1C052E"
        />
        <path
          d="m69.96 41.683 4.278-.388-1.96 5.182-2.319-4.794Z"
          fill="#F3DFD7"
        />
        <path
          d="M72.886 47.367c-1.648.034-3.955-2.545-10.34-1.396-6.386 1.149-8.296 7.215-1.448 17.819 6.849 10.604 10.52 11.577 12.683 11.575 2.162-.002 7.8-5.731 10.59-11.85 2.79-6.12 6.034-15.306.186-17.742-5.847-2.436-8.515 1.532-11.674 1.598"
          fill="#00923D"
        />
        <path
          d="M72.969 50.544c-1.18.028-2.826-1.79-7.393-.977-4.566.813-5.938 5.11-1.045 12.566s7.714 9.124 9.253 9.122c1.539-.002 5.394-5.015 7.391-9.335 1.997-4.32 4.322-10.8.143-12.508-4.178-1.709-6.088 1.086-8.349 1.142"
          fill="#0093D3"
        />
        <path
          d="M93.897 42.383s-2.23 3.98-1.938 11.74c.292 7.762 2.79 21.8 2.79 21.8l.559-.034v-.478l.182-.01-.013.51.489-.03.008-.539.161-.01.105.583.426-.026.04-.702 9.748-1.094.197 1.254.336.011-.008-1.377.398-.024.104 1.352.607-.072-.005-1.377.287-.017.109 1.427.489-.03s2.873-13.225 2.509-22.578c-.364-9.352-2.166-12.01-2.166-12.01l-1.697-.052-1.559 4.655-9.043.45-1.767-3.787-1.349.465Z"
          fill="#F3DFD7"
        />
        <path
          d="M91.902 51.952c.023 1.626.767 4.48 4.533 4.663 3.592.174 5.337-2.25 5.227-4.681-.147-3.192-1.81-4.62-4.661-4.69-3.559-.1-5.127 2.633-5.096 4.708"
          fill="#EA5425"
        />
        <path
          d="M101.536 51.733c.019 1.61.757 4.428 4.476 4.61 3.547.17 5.272-2.221 5.164-4.624-.145-3.157-1.789-4.568-4.604-4.637-3.517-.086-5.066 2.604-5.036 4.651Z"
          fill="#EA5425"
        />
        <path
          d="M92.685 51.392c.012 1.085.499 2.99 3.039 3.11 2.397.117 3.563-1.483 3.489-3.125-.099-2.13-1.208-3.092-3.11-3.128-2.375-.058-3.423 1.757-3.402 3.142"
          fill="#BF318A"
        />
        <path
          d="M93.533 50.916c.004.484.11 1.342 1.35 1.384 1.241.041 1.581-.667 1.55-1.39-.058-.946-.54-1.366-1.383-1.388a1.39 1.39 0 0 0-1.498 1.393"
          fill="#E8308A"
        />
        <path
          d="M94.01 50.643a.473.473 0 0 0 .51.53c.473.015.618-.257.601-.531a.488.488 0 0 0-.526-.532.532.532 0 0 0-.575.532"
          fill="#1C052E"
        />
        <path
          d="M102.149 51.502c.015 1.14.536 3.134 3.168 3.259 2.506.12 3.726-1.57 3.648-3.269-.101-2.232-1.264-3.228-3.256-3.284-2.482-.06-3.579 1.84-3.561 3.288"
          fill="#BF318A"
        />
        <path
          d="M102.802 50.64c.01.515.119 1.433 1.443 1.494 1.324.062 1.695-.714 1.658-1.484-.062-1.016-.574-1.47-1.481-1.493a1.492 1.492 0 0 0-1.619 1.495"
          fill="#E8308A"
        />
        <path
          d="M103.261 50.43a.478.478 0 0 0 .127.39.467.467 0 0 0 .384.143c.469.016.617-.256.601-.53a.483.483 0 0 0-.317-.504.49.49 0 0 0-.21-.028.531.531 0 0 0-.575.532m-2.743 4.761 2.321-.208-1.064 2.81-1.257-2.602Z"
          fill="#1C052E"
        />
        <path
          d="M101.893 59.208c-.895.02-2.142-1.38-5.605-.754-3.464.626-4.511 3.913-.786 9.657 3.725 5.745 5.711 6.28 6.879 6.278 1.168-.002 4.228-3.108 5.741-6.43 1.514-3.32 3.272-8.297.102-9.615-3.171-1.317-4.617.83-6.331.864"
          fill="#EA5425"
        />
        <path
          d="M102.032 60.972c-.591.011-1.419-.9-3.712-.492-2.292.409-2.981 2.56-.524 6.31 2.458 3.751 3.873 4.583 4.645 4.58.773-.002 2.696-2.516 3.713-4.687 1.017-2.17 2.171-5.423.071-6.28-2.101-.856-3.057.545-4.192.573"
          fill="#0093D3"
        />
      </g>
      <rect
        x={38.118}
        y={13.74}
        width={76}
        height={116}
        rx={8}
        transform="rotate(-3.487 38.118 13.74)"
        stroke="#fff"
        strokeWidth={4}
      />
      <rect x={88} y={3} width={76} height={116} rx={8} fill="#D9BBBE" />
      <path
        d="M113.67 91.15c.019-.54.122-26.497.179-30.553.04-2.866.184-5.48.067-5.678-.27-.468-2.163 2.974-6.031 2.404-3.278-.47-5.49-3.175-5.023-6.644.468-3.469 3.546-4.967 6.273-4.553 3.878.59 4.438 3.994 4.895 3.72.184-.11.116-2.163.078-4.163-.038-2.001-.054-3.907-.289-4.186-.468-.565-4.666-2.104-4.882-5.57-.195-3.126 1.785-6.886 6.81-6.59 5.631.336 6.167 5.027 5.499 7.618-.985 3.823-5.217 4.453-5.704 4.848-.271.221-.271 1.957-.29 3.839-.019 1.882-.056 3.834.222 4.056.563.468 1.804-3.047 5.561-2.742 4.024.327 5.139 2.163 5.301 5.37.135 2.68-2.12 5.159-5.185 5.21-3.619.062-5.474-2.785-5.882-2.685-.146.038-.133 2.782-.16 5.81-.041 4.127-.251 30.2-.27 30.622a.603.603 0 0 1-.224.392.59.59 0 0 1-.948-.538"
        fill="#DFDFCC"
      />
      <path
        d="M120.21 48.297c1.736-.24 4.703.682 4.779 3.54.076 2.857-2.072 4.136-3.537 4.182-2.064.07-4.057-1.014-4.433-3.371a3.78 3.78 0 0 1 1.786-3.849 3.79 3.79 0 0 1 1.405-.502"
        fill="#EC621D"
      />
      <path
        d="M120.391 49.165c1.339-.186 3.632.525 3.689 2.731.057 2.206-1.598 3.196-2.731 3.245-1.593.051-3.135-.785-3.422-2.607a2.932 2.932 0 0 1 1.379-2.971c.333-.2.701-.331 1.085-.387"
        fill="#4C732B"
      />
      <path
        d="M120.616 50.246c.846-.113 2.288.333 2.323 1.723.035 1.39-1.006 2.011-1.72 2.036-1.006.035-1.975-.492-2.164-1.642a1.846 1.846 0 0 1 .333-1.383 1.828 1.828 0 0 1 1.22-.734"
        fill="#EDCA00"
      />
      <path
        d="M114.479 31.28c1.788-.247 4.849.697 4.914 3.639.065 2.942-2.131 4.253-3.635 4.302-2.125.07-4.176-1.044-4.56-3.47a3.894 3.894 0 0 1 3.281-4.471"
        fill="#E6AA00"
      />
      <path
        d="M107.587 47.297c1.94-.27 5.253.763 5.337 3.95.084 3.188-2.316 4.618-3.952 4.675-2.304.073-4.533-1.135-4.947-3.766a4.234 4.234 0 0 1 .76-3.18 4.224 4.224 0 0 1 2.802-1.687"
        fill="#009B99"
      />
      <path
        d="M107.915 48.865c1.22-.168 3.305.481 3.359 2.49.054 2.01-1.46 2.91-2.488 2.942-1.453.046-2.856-.714-3.119-2.371a2.665 2.665 0 0 1 2.248-3.06Z"
        fill="#007BC4"
      />
      <path
        d="M129.035 89.777s.287-27.81.219-27.92c-.159-.27-1.236 1.7-3.435 1.37-1.866-.27-3.129-1.819-2.861-3.785.268-1.965 2.02-2.828 3.573-2.593 2.209.336 2.529 2.274 2.788 2.12.106-.065.068-1.227.043-2.374-.024-1.146-.029-2.225-.162-2.385-.27-.319-2.658-1.197-2.783-3.171-.111-1.78 1.02-3.923 3.881-3.753 3.208.192 3.516 2.863 3.132 4.326-.562 2.18-2.975 2.539-3.245 2.763-.154.127-.154 1.114-.163 2.188-.008 1.073-.032 2.184.125 2.317.322.27 1.028-1.736 3.167-1.563 2.294.187 3.078 1.368 3.059 3.204-.016 1.236-1.055 2.745-2.991 2.823-2.061.084-3.119-1.587-3.351-1.528-.084.02.413 27.98.413 27.98l-1.409-.02Z"
        fill="#A9924D"
      />
      <path
        d="M132.789 57.833c1.101-.151 2.975.433 3.027 2.24.051 1.805-1.312 2.62-2.24 2.649-1.306.043-2.569-.644-2.804-2.136a2.403 2.403 0 0 1 1.128-2.435c.273-.164.575-.272.889-.318"
        fill="#EA5040"
      />
      <path
        d="M132.906 58.418c.846-.116 2.298.333 2.334 1.73.035 1.398-1.012 2.02-1.729 2.044-1.008.033-1.982-.494-2.163-1.649a1.846 1.846 0 0 1 .873-1.88c.211-.127.444-.21.687-.245"
        fill="#00A99F"
      />
      <path
        d="M133.071 59.185c.481-.065 1.303.192 1.325.982a1.08 1.08 0 0 1-.982 1.16 1.122 1.122 0 0 1-1.228-.936 1.044 1.044 0 0 1 .191-.787 1.049 1.049 0 0 1 .694-.419"
        fill="#F18700"
      />
      <path
        d="M129.525 48.133c1.13-.155 3.061.446 3.11 2.303.049 1.858-1.352 2.704-2.302 2.723-1.352.046-2.642-.66-2.886-2.196a2.474 2.474 0 0 1 .447-1.85 2.465 2.465 0 0 1 1.631-.98"
        fill="#239F38"
      />
      <path
        d="M125.652 57.506c1.103-.151 2.988.435 3.037 2.252.049 1.817-1.317 2.629-2.25 2.661-1.312.043-2.583-.646-2.818-2.147a2.401 2.401 0 0 1 1.137-2.447c.274-.164.578-.273.894-.319Z"
        fill="#00A99F"
      />
      <path
        d="M125.8 58.229c.774-.106 2.094.305 2.126 1.576a1.708 1.708 0 0 1-.925 1.68 1.719 1.719 0 0 1-.649.183c-.919.03-1.806-.452-1.971-1.503a1.682 1.682 0 0 1 1.419-1.936"
        fill="#EA5040"
      />
      <path
        d="M126.017 58.983c.422-.057 1.141.165 1.16.857a.925.925 0 0 1-.218.688.94.94 0 0 1-.642.329.982.982 0 0 1-1.082-.811.917.917 0 0 1 .774-1.055M136.308 86.665c.027-.709.162-29.983.241-35.358.051-3.805.241-7.274.089-7.53-.376-.622-2.883 3.958-8.003 3.187-4.346-.657-7.281-4.234-6.661-8.833.619-4.6 4.703-6.59 8.319-6.038 5.139.782 5.888 5.294 6.491 4.935.244-.149.157-2.858.106-5.527-.057-2.612-.073-5.18-.384-5.55-.62-.747-6.191-2.788-6.492-7.388-.24-4.145 2.386-9.136 9.058-8.741 7.471.446 8.179 6.668 7.303 10.104-1.306 5.07-6.921 5.908-7.573 6.433-.363.291-.363 2.595-.384 5.09-.022 2.434-.076 5.087.295 5.408.746.62 2.396-4.055 7.375-3.636 5.339.435 6.827 2.866 7.032 7.133.179 3.555-2.821 6.832-6.886 6.902-4.798.081-7.262-3.696-7.803-3.56-.192.048-.175 3.687-.211 7.705-.054 5.473-.332 34.91-.359 35.47-.052.973-1.607 1.019-1.558-.195"
        fill="#3F2B3E"
      />
      <path
        d="M144.985 34.97c2.304-.319 6.237.906 6.337 4.697.1 3.79-2.746 5.489-4.677 5.559-2.737.092-5.385-1.352-5.88-4.475a5.022 5.022 0 0 1 4.233-5.77"
        fill="#CBBC3E"
      />
      <path
        d="M145.223 36.122c1.779-.246 4.819.698 4.895 3.623.076 2.926-2.12 4.237-3.624 4.289-2.113.07-4.157-1.041-4.539-3.459a3.87 3.87 0 0 1 1.83-3.94 3.9 3.9 0 0 1 1.438-.513"
        fill="#4C732B"
      />
      <path
        d="M145.523 37.558c1.122-.152 3.035.44 3.083 2.285.049 1.843-1.336 2.668-2.282 2.703-1.334.044-2.619-.654-2.862-2.163a2.444 2.444 0 0 1 .438-1.839 2.44 2.44 0 0 1 1.623-.97"
        fill="#0083CB"
      />
      <path
        d="M128.254 33.645c2.572-.354 6.964 1.012 7.075 5.24.111 4.23-3.07 6.127-5.239 6.2-3.056.098-6.012-1.503-6.564-4.996a5.602 5.602 0 0 1 2.647-5.7 5.608 5.608 0 0 1 2.081-.744"
        fill="#C48EBF"
      />
      <path
        d="M128.676 35.727c1.622-.224 4.384.636 4.454 3.3.07 2.662-1.934 3.86-3.3 3.903-1.928.063-3.786-.946-4.138-3.147a3.533 3.533 0 0 1 2.975-4.056"
        fill="#EDCA00"
      />
      <path
        d="M137.385 12.398c2.369-.327 6.415.93 6.515 4.824.1 3.893-2.824 5.643-4.828 5.708-2.815.094-5.536-1.382-6.047-4.597a5.15 5.15 0 0 1 .936-3.875 5.162 5.162 0 0 1 3.418-2.054"
        fill="#F39D99"
      />
      <rect
        x={88}
        y={3}
        width={76}
        height={116}
        rx={8}
        stroke="#fff"
        strokeWidth={4}
      />
      <g transform="rotate(3.956 65.074 1880.801) skewX(.176)">
        <rect
          x={1.863}
          y={2.134}
          width={71.122}
          height={112.683}
          rx={8}
          fill="#EAEAEA"
        />
        <rect
          x={1.863}
          y={2.134}
          width={71.122}
          height={112.683}
          rx={8}
          stroke="#fff"
          strokeWidth={4}
        />
      </g>
      <text
        transform="rotate(1.345 -612.804 5846.16)"
        fill="#000"
        fillOpacity={0.6}
        xmlSpace="preserve"
        style={{
          whiteSpace: 'pre',
        }}
        fontFamily="Bangers"
        fontSize={24}
        letterSpacing="0em"
      >
        <tspan x={17.386} y={21.424} />
        <tspan x={17.386} y={47.424}>
          {'?'}
        </tspan>
      </text>
      <g clipPath="url(#d)">
        <rect
          x={175.9}
          y={1}
          width={80}
          height={120}
          rx={10}
          transform="rotate(4.253 175.9 1)"
          fill="#35A936"
        />
        <g clipPath="url(#e)">
          <path
            d="M171.769 56.762c-.882 4.72 10.645 22.749 33.996 24.884 19.53 1.788 39.379-12.758 39.308-17.164-.07-4.406-11.371-23.084-35.594-24.886-18.62-1.384-36.387 10.086-37.71 17.166Z"
            fill="#E6007E"
          />
          <path
            d="M175.213 57.54c-.772 4.133 10.19 19.691 30.682 21.566 17.143 1.568 35.679-11.029 35.626-14.885-.053-3.857-11.086-20.45-32.349-22.031-16.346-1.216-32.787 9.133-33.951 15.35"
            fill="#EA5426"
          />
          <path
            d="M206.312 46.008c7.598-.584 17.747 3.941 17.216 14.875-.532 10.933-9.082 15.219-14.686 14.988-7.895-.321-15.2-5.03-15.942-14.15a14.588 14.588 0 0 1 13.412-15.713"
            fill="#008CCD"
          />
          <path
            d="M214.788 62.469c-.12-1.535-.797-4.715-1.009-5.614-.212-.898-.718-1.55-1.439-2.396-.859-1.013-1.647-1.768-1.586-2.13.062-.363 1.526-.881 1.558-2.666.039-2.273-1.915-3.378-3.494-3.256a3 3 0 0 0-2.786 3.265c.179 1.625 1.354 1.994 1.343 2.392-.011.398-1.049.895-2.016 1.685-.794.65-1.508 1.507-1.804 2.38-.296.875-1.319 3.846-1.667 5.346-.32 1.377 1.621 1.737 1.955.53.333-1.205.831-3.184 1.043-3.822.137-.415.532-.373.473.147-.06.52-2.11 13.876-2.311 14.186-.201.31-.493.442-.548.823-.144 1.016 1.595.95 2.656 1.03 1.062.079 1.627-.09 1.798-.79.084-.336.653-5.204.742-6.115.023-.32.092-.525.264-.488.173.037.208.201.19.522-.068.912-.207 5.813-.174 6.158.066.717.597.967 1.661 1.046 1.065.08 2.772.4 2.779-.626.002-.385-.269-.551-.419-.895-.15-.343-.202-13.857-.185-14.371.017-.515.412-.501.487-.076.115.663.328 2.731.477 3.97.15 1.24 2.125 1.175 2.012-.235"
            fill="#A9924D"
          />
          <path
            d="M209.988 54.6c.214.017 1.219-.504 1.9.193.479.492.356 1.355-.404 2.12-.916.919-1.796 1.18-1.945 1.159-.214-.016-.997-.455-1.616-1.596-.518-.961-.294-1.753.212-2.09.888-.594 1.644.205 1.866.216"
            fill="#E6007E"
          />
          <path
            d="M209.949 55.132c.163.013.933-.483 1.377-.027.313.32.227.918-.27 1.415a3.33 3.33 0 0 1-1.437.901c-.14-.01-.76-.49-1.164-1.238-.338-.626-.295-1.064.032-1.287.647-.444 1.311.23 1.461.242"
            fill="#EA5426"
          />
        </g>
      </g>
      <rect
        x={177.746}
        y={3.143}
        width={76}
        height={116}
        rx={8}
        transform="rotate(4.253 177.746 3.143)"
        stroke="#fff"
        strokeWidth={4}
      />
      <g clipPath="url(#f)">
        <rect
          x={220.344}
          y={4}
          width={80}
          height={120}
          rx={10}
          transform="rotate(7.346 220.344 4)"
          fill="#4F1E6F"
        />
        <g clipPath="url(#g)">
          <path
            d="M313.389 70.145c.15 7.697-6.049 9.545-8.697 13.785-2.648 4.24.067 9.107-6.088 12.484-6.078 3.345-9.555-4.2-14.835-4.1-5.281.102-11.476 2.576-16.038-3.736-3.347-4.634 1.771-9.187 1.539-14.235-.231-5.048-8.036-7.714-3.285-15.32 3.138-5.032 11.601-3.88 14.355-4.767 4.115-1.315 5.51-9.876 13.271-8.034 7.843 1.86 5.554 9.455 7.719 11.88 2.164 2.426 11.896 4.033 12.058 12.048"
            fill="#E22414"
          />
          <path
            d="M299.461 71.462c.066 3.348-2.623 4.14-3.772 5.982-1.148 1.84.029 3.95-2.644 5.416-2.633 1.45-4.141-1.822-6.434-1.784-2.293.039-4.976 1.119-6.965-1.613-1.452-2.01.768-3.986.667-6.174-.1-2.188-3.477-3.346-1.416-6.648 1.362-2.186 5.035-1.69 6.226-2.06 1.792-.582 1.905-4.34 5.272-3.543 3.406.806 2.894 4.15 3.837 5.2.943 1.049 5.161 1.75 5.229 5.224Z"
            fill="#D52085"
          />
          <path
            d="M243.087 116.85c15.522 1.238 24.327-10.064 24.811-21.83.599-14.511-10.334-21.843-21.801-22.865-13.252-1.196-22.21 9.65-23.483 20.8-1.421 12.511 6.515 22.78 20.463 23.894"
            fill="#13A538"
          />
          <path
            d="M233.177 105.341c4.259 4.391 14.755 7.23 21.813 1.202 6.387-5.451 9.221-14.399 2.921-21.65-6.94-7.985-18.041-7.933-23.611-1.852-6.568 7.174-7.39 15.833-1.122 22.295"
            fill="#A9924D"
          />
          <path
            d="M257.41 101.11c3.779-7.59-2.703-9.26-3.097-10.566-.29-.958 3.906-5.669-2.432-9.138-7.283-3.982-10.11 3.161-10.919 3.448-.809.287-6.271-3.288-9.733 4.095-3.741 7.984 3.33 9.775 3.674 10.616.394.95-2.848 5.953 2.853 8.892 6.013 3.098 8.417-3.377 9.228-3.511.811-.134 6.554 3.945 10.426-3.836"
            fill="#B29CCB"
          />
          <path
            d="M249.423 92.294c-.603-1.986-3.289-3.642-5.643-2.729a4.744 4.744 0 0 0-2.682 2.484 4.72 4.72 0 0 0-.11 3.65c.727 1.93 2.61 3.328 5.476 2.597 1.961-.503 3.84-3.122 2.959-6.002Z"
            fill="#877D23"
          />
          <path
            d="M211.954 49.067c-4.136-11.611-1.777-31.786 15.458-39.097 15.598-6.617 34.107-.134 40.978 14.449 10.284 21.821-1.916 39.232-17.817 44.174-15.509 4.833-32.53-2.455-38.607-19.525"
            fill="#DE007E"
          />
          <path
            d="M220.798 47.121c-2.956-8.287-1.147-21.626 10.922-27.392 9.888-4.725 23.195-.45 28.102 9.967 7.354 15.58-.843 27.053-12.209 30.59-11.081 3.454-22.461-.96-26.815-13.165"
            fill="#E73B23"
          />
          <path
            d="M228.408 44.136c-1.741-4.877-.566-12.839 6.686-15.915 6.56-2.782 14.054-.335 16.944 5.804 4.331 9.173-.803 16.503-7.496 18.59-6.524 2.033-13.573-1.285-16.134-8.474"
            fill="#A9924D"
          />
        </g>
      </g>
      <rect
        x={222.072}
        y={6.239}
        width={76}
        height={116}
        rx={8}
        transform="rotate(7.346 222.072 6.24)"
        stroke="#fff"
        strokeWidth={4}
      />
      <g transform="rotate(12.438 71.67 1234.817) skewX(.176)">
        <rect
          x={1.528}
          y={2.385}
          width={71.122}
          height={112.683}
          rx={8}
          fill="#EAEAEA"
        />
        <rect
          x={1.528}
          y={2.385}
          width={71.122}
          height={112.683}
          rx={8}
          stroke="#fff"
          strokeWidth={4}
        />
      </g>
      <text
        transform="rotate(11.715 -25.146 1387.13)"
        fill="#000"
        fillOpacity={0.6}
        xmlSpace="preserve"
        style={{
          whiteSpace: 'pre',
        }}
        fontFamily="Bangers"
        fontSize={24}
        letterSpacing="0em"
      >
        <tspan x={10.182} y={21.424}>
          {numberOfCards}
        </tspan>
        <tspan x={9.889} y={47.424}>
          {'av '}
        </tspan>
        <tspan x={8.213} y={73.424}>
          {numberOfPlayableCards}
        </tspan>
      </text>
      <defs>
        <clipPath id="a">
          <rect
            x={0.43}
            y={21.874}
            width={80}
            height={120}
            rx={10}
            transform="rotate(-9.26 .43 21.874)"
            fill="#fff"
          />
        </clipPath>
        <clipPath id="b">
          <path
            fill="#fff"
            transform="rotate(-9.261 190.889 -10.389)"
            d="M0 0h66.611v92.977H0z"
          />
        </clipPath>
        <clipPath id="c">
          <rect
            x={36}
            y={11.865}
            width={80}
            height={120}
            rx={10}
            transform="rotate(-3.487 36 11.865)"
            fill="#fff"
          />
        </clipPath>
        <clipPath id="d">
          <rect
            x={175.9}
            y={1}
            width={80}
            height={120}
            rx={10}
            transform="rotate(4.253 175.9 1)"
            fill="#fff"
          />
        </clipPath>
        <clipPath id="e">
          <path
            fill="#fff"
            transform="rotate(4.253 -410.242 2350.959)"
            d="M0 0h73.691v42.215H0z"
          />
        </clipPath>
        <clipPath id="f">
          <rect
            x={220.344}
            y={4}
            width={80}
            height={120}
            rx={10}
            transform="rotate(7.346 220.344 4)"
            fill="#fff"
          />
        </clipPath>
        <clipPath id="g">
          <path
            fill="#fff"
            transform="scale(-1 1) rotate(-7.346 -24.362 2503.672)"
            d="M0 0h106.885v108.51H0z"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export default CardCollectionIcon
